import { render, staticRenderFns } from "./GateIsBent.vue?vue&type=template&id=72dc236f&scoped=true"
import script from "./GateIsBent.vue?vue&type=script&lang=ts"
export * from "./GateIsBent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc236f",
  null
  
)

export default component.exports